// addition.js - Addition problem generator
import { BasicProblem } from './ui.js';
import { getRandomInt, state } from './utils.js';

export function generateAdditionProblem(): BasicProblem {
    const type = document.querySelector<HTMLInputElement>('input[name="additionType"]:checked')?.value || "upTo10";

    let a, b;
    const useZero = !state.zeroUsedInWorksheet && Math.random() < 0.1;

    switch(type) {
        case 'upTo10':
            if (useZero) {
                state.zeroUsedInWorksheet = true;
                if (Math.random() < 0.5) {
                    a = 0;
                    b = getRandomInt(1, 9);
                } else {
                    a = getRandomInt(1, 9);
                    b = 0;
                }
            } else {
                a = getRandomInt(1, 7);
                b = getRandomInt(1, 9 - a);
            }
            break;

        case 'between10and20':
            a = getRandomInt(10, 20);
            if (Math.random() < 0.7) {
                b = getRandomInt(5, 9);
            } else {
                b = getRandomInt(1, 4);
            }
            break;

        case 'between20and100':
            do {
                a = getRandomInt(11, 70);
                b = getRandomInt(8, 29);
            } while (a + b <= 20 || a + b > 100);
            break;

        case 'between100and1000':
            do {
                a = getRandomInt(50, 700);
                b = getRandomInt(40, 299);
            } while (a + b <= 100 || a + b > 1000);
            break;

        default:
            a = 1;
            b = 1;
    }

    return new BasicProblem(
        String(a).padStart(4, ' '),
        String(b).padStart(4, ' '),
        '+'
    );
}